<template>
  <div>
    <div class="row" v-if="activity.status != 'COMPLETED' && activity.status != 'REJECTED' && activity.status != 'CANCELLED'">
      <b-form-group
        id="input-account-record"
        :label="$t('training-view.accountRecord')"
        label-for="account-record"
        label-align="left"
        class="col-3"
      >
        <b-select
        id="topic-type"
        v-model="itemToAdd.category.id" 
        text-field="title"
        value-field="id"
        :options="accountingCategories">
        
        >
        </b-select>
      </b-form-group>
      <b-form-group
        id="input-item-description"
        :label="$t('training-view.description')"
        label-for="input-description"
        label-align="left"
        class="col-lg-6 col-md-5"
      >
       <b-form-input
          id="input-description"
          type="text"
          v-model="itemToAdd.description"
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-item-amount"
        :label="$t('training-view.amount')"
        label-for="input-amount"
        label-align="left"
        class="col-lg-1 col-md-2"
      >
       <b-form-input
          id="input-location"
          type="number"
          v-model="itemToAdd.value"
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-button variant="primary" class="esep-blue-bg col-lg-1 col-sm-2 w-50 h-50 my-auto" @click="addAccountItem()">
          {{ $t("common.add")}}</b-button>
    <hr />
    </div>    
    <b-table 
      :items="accountItems"
      :fields="fields"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
    > 

      <template v-slot:cell(credit)="row">
        {{ displayCredit(row.item) }}
      </template>

      <template v-slot:cell(charge)="row">
        {{ displayCharge(row.item) }}
      </template>

      <template v-slot:cell(action)="row">
        <b-button
          v-if="row.item.id != -1"
          size="sm"
          @click="deleteAccountItem(row)"
          variant="transparent"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("training-view.emptyItemsTable") }}</h6>
      </template>

    </b-table>
  </div>
</template>

<script>
import trainingService from "../../services/training.service";
import {handleApiError} from "../../services/error.service";

export default {
  props: {
    activity: {
      type: Object
    }
  },
  mounted() {
    this.getAccountingCategories();
    this.getAccountingSums();
  },
  data() {
    return {
      itemToAdd: {
        value: 0,
        category: {
          id: null
        },
        description: ""
      },
      fields: [
        { key: "category.title", label: "Κατηγορία", sortable: false, thClass: 'text-left', tdClass: 'text-left'},
        { key: "description", label: "Περιγραφή", sortable: false , formatter: "formatEmptyDesc", thClass: 'text-left', tdClass: 'text-left'},
        { key: "charge", label: "Έσοδα", sortable: false },
        { key: "credit", label: "Έξοδα", sortable: false },
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      accountItems: null,
      reportType: 'FORECAST',
      chargeSum: null,
      creditSum: null,
      accountingCategories: null
    }
  },
  methods: {
    addAccountItem() {
      this.$log.debug(this.itemToAdd)
      trainingService.addAccountingItem(this.activity.id, this.itemToAdd.category.id , this.itemToAdd.description, this.itemToAdd.value , this.reportType).then(
        (response) => {
          // this.$log.debug("accounting")
          this.$log.debug(response.data);
          this.itemToAdd = {
              value: 0,
              category: {
                id: null
              },
              description: ""
            };
          this.getAccountingSums();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    deleteAccountItem(row) {
      trainingService.deleteAccountingItem(this.activity.id, row.item.id).then(
        (response) => {
          // this.$log.debug("chargeSum")
          this.$log.debug(response.data)
          this.itemToAdd = {
            value: 0,
            category: {
              id: null
            },
            description: ""
          };
          this.getAccountingSums();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getAccountingSums() {
      trainingService.getActivitysAccountingSum(this.activity.id, this.reportType,'CREDIT').then(
        (response) => {
          // this.$log.debug("accounting")
          this.$log.debug(response.data);
          this.creditSum = response.data.sum;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          if(errorMessage[0].code != "NO_SUM_FOR_CRITERIA") {
            this.$emit('error:api', errorMessage);
          }          
        }
      )
      trainingService.getActivitysAccountingSum(this.activity.id, this.reportType,'CHARGE').then(
        (response) => {
          // this.$log.debug("chargeSum")
          // this.$log.debug(response.data)
          this.chargeSum = response.data.sum;
          this.getAccountingItems();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$log.debug(errorMessage)
          if(errorMessage[0].code != "NO_SUM_FOR_CRITERIA") {
            this.$emit('error:api', errorMessage);
          }  
        }
      )
    },
    getAccountingItems() {
      trainingService.getAccountingItems(this.activity.id, this.reportType).then(
        (response) => {
          this.$log.debug("accountItems")
          this.$log.debug(response.data[0])
          this.accountItems = response.data;
          this.accountItems.push( { id: -1, creditSum: this.creditSum, chargeSum: this.chargeSum , description: "Σύνολο"});
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getAccountingCategories() {
      trainingService.getAccountingCategories().then(
        (response) => {
          this.$log.debug("accountingCategories")
          this.$log.debug(response.data)
          this.accountingCategories = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    displayCredit(item) {
      let credit = null;
      if(item.id != -1) {
        if(item.category.recordType == 'CREDIT') {
          credit = item.value / 100
        } 
      } else {
        credit = item.creditSum;
      }
      return credit;
    },
    displayCharge(item) {
      let charge = null;
      if(item.id != -1) {
        if(item.category.recordType == 'CHARGE' ) {
          charge = item.value / 100
        } 
      } else {
        charge = item.chargeSum;
      }
      return charge;
    },
    formatEmptyDesc(description) {
      return description != null && description != "" ? description : '-';
    }
  }
}
</script>